import type { Course, CourseDetail } from './vuex';
import type { Filters } from '@/views/Enrollments/List';

export default {
  courses: [] as Course[],
  course: null as CourseDetail | null,
  sort: '-updatedAt',
  pageNumber: 1,
  filters: {
    statuses: [],
    courseTypes: [],
    queryString: '',
  } as Filters,
};
